module.exports = __webpack_public_path__ + "static/media/2025_aufhaenger.1cdb6f3b.png";